module.exports = __webpack_public_path__ + "static/media/fg-palm.4c6a50ce.svg";